import React from "react";
import { node, bool } from "prop-types";
import { useHistory } from "react-router-dom";
import useSearchValues from "../../common/routing/useSearchValues.js";
import Select from "../Select/Select.jsx";
import * as R from "ramda";
const propTypes = {
  title: node,
  resultsRange: node,
  showSort: bool,
};

const ResultsHeader = props => {
  const { resultsRange, title, showSort } = props;
  const { searchValues, getLocationFor } = useSearchValues();
  const history = useHistory();

  //get new url
  const handleSortChange = value => {
    if (value) {
      const val = value.split("-");
      const newUrl = getLocationFor({
        sort_by: val[0],
        sort_order: val[1],
        page: 1,
      });
      history.push(newUrl);
    }
  };

  //sort_by = field_available_on_value, field_price_value or undefined
  //sort_order = ASC, DESC or undefined

  const items = [
    { id: "field_available_on_value-ASC", label: "Available" },
    { id: "field_price_value-ASC", label: "Lowest price first" },
    { id: "field_price_value-DESC", label: "Highest price first" },
  ];

  const lookupValueById = (id, values) => {
    return R.compose(
      // null is important so the <Select> knows this value is controlled
      R.defaultTo(items[0]),
      R.find(R.propEq("id", id)),
      R.defaultTo([]),
    )(items);
  };

  return (
    <div className="results__header">
      <div className="results__title coh-style-black coh-style-heading-3-size">
        {title}
      </div>
      <div className="results__range coh-style-heading-5-size coh-style-black">
        {showSort ? (
          <div className="action-bar__filters action-bar__filters--sort-wrap">
            Sort:
            <div className="action-bar__filter action-bar__filter--sort">
              <Select
                selectProps={{
                  items,
                  itemToString: R.prop("label"),
                  selectedItem: lookupValueById(
                    `${searchValues.sort_by}-${searchValues.sort_order}`,
                  ),
                  onSelectedItemChange: changes => {
                    handleSortChange(R.prop("id", changes.selectedItem));
                  },
                }}
                style={{ width: 200 }}
                showClear={false}
              />
            </div>
          </div>
        ) : (
          resultsRange
        )}
      </div>
    </div>
  );
};

ResultsHeader.propTypes = propTypes;
export default ResultsHeader;
